import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { getItemInfo } from '../../../../components/ItemFetch';
import CertificateLayoutPreview from '../../../../admin/components/Certificate/CertificatePreview';
import DarkCertificatePreview from '../../../../admin/components/Certificate/DarkCertificatePreview';

class CertificatePopup extends Component {
  static contextTypes = {
    getFeatureFlag: PropTypes.func,
    getCurrentUserInfo: PropTypes.func
  };

  renderCertificate = isDarkTheme => {
    const {
      showCertificate,
      fetchingTemplate,
      certificate,
      certificateData,
      userName,
      userEmail
    } = this.props;
    if (!showCertificate) {
      return null;
    }

    if (fetchingTemplate) {
      if (isDarkTheme) {
        return <DarkCertificatePreview loading={true} />;
      }
      return <CertificateLayoutPreview loading={true} />;
    }

    const { certificateSettings } = certificateData;
    const { approverId, score, completionDate } = certificateData.certificateData;
    const user = this.context.getCurrentUserInfo();
    let instructorName = '';

    if (certificateSettings.includeApprover) {
      instructorName = getItemInfo(
        'users',
        approverId,
        'name',
        () => {
          this.forceUpdate();
        },
        '.....'
      );
    }

    const certificateInfo = {
      certificateSettings: {
        includeScore: certificateSettings.includeScore,
        includeApprover: certificateSettings.includeApprover,
        includeCompletionDate: certificateSettings.includeCompletionDate,
        dontPublishOnLinkedIn: certificateSettings.dontPublishOnLinkedIn
      },
      previewCertificateTemplate:
        certificate && certificate.templateInfo && certificate.templateInfo.template,
      companyDetails: {
        companyName: user.company.name,
        companyImage: user.company.headerImage
      },
      certificateDetails: {
        activityType: certificateData.activityType.toLowerCase(),
        activityTitle: certificateData.title,
        instructorName,
        score: `${score}%`,
        completionDate: format(completionDate, 'Do MMMM, YYYY'),
        completionDateUnformatted: completionDate,
        company: user.company.name,
        number: certificateData.issueId,
        from: format(completionDate, 'MMMM YYYY'),
        to: 'This certificate doesn’t expire.',
        url: `http://${user.company_subdomain}.${window.location.host.split('.')[1] ||
          'lyearn'}.com/share.html?type=certificate&issueId=${certificateData.issueId}`
      },
      userDetails: {
        userName: userName || user.name,
        emailId: userEmail || user.email
      },
      onLayoutCloseClick: event => {
        this.props.handleCloseCertificiate(event);
      },
      renderActions: true,
      closeButton: true
    };
    if (isDarkTheme) {
      return <DarkCertificatePreview loading={false} {...certificateInfo} />;
    }
    return <CertificateLayoutPreview loading={false} {...certificateInfo} />;
  };

  render() {
    const isDarkTheme = this.context.getFeatureFlag && this.context.getFeatureFlag('dark-theme');
    return this.renderCertificate(isDarkTheme);
  }
}

export default CertificatePopup;
